<script>
import $ from 'jquery'
import common from '@/common.js'
import setting from '@/setting.js'

export default {
    name: 'ThreeList',
    props: ['mode', 'atBatBalls', 'allBalls', 'playing', 'nowID', 'colors', 'savedBalls', 'enableMultiPos', 'baseBallIndex', 'getBallText', 'PTReviewBalls', 'threeListSortMode'],
    emits: ['single-pitch', 'open-search-modal', 'set-list-sort-mode', 'toggle-saved-ball', 'change-base-ball', 'edit-multi-positions', 'remove-saved-ball'],
    data() {
        return {
            setting,
            temp_kinds: [
                'ストレート',
                'カーブ',
                'ストレート',
                'スライダー',
                'チェンジアップ'
            ],
            opened: true,
            priority: [
                'Fastball',
                'ChangeUp',
                'Curveball',
                'Cutter',
                'KnuckleBall',
                'Sinker',
                'Slider',
                'Splitter'
            ],
            sortedArray: {
                'Fastball': [],
                'ChangeUp': [],
                'Curveball': [],
                'Cutter': [],
                'KnuckleBall': [],
                'Sinker': [],
                'Slider': [],
                'Splitter': []
            },
            pitchTypeName: {
                'Fastball': '速球',
                'ChangeUp': 'チェンジアップ',
                'Curveball': 'カーブ',
                'Cutter': 'カットボール',
                'KnuckleBall': 'ナックル',
                'Sinker': 'シンカー',
                'Slider': 'スライダー',
                'Splitter': 'スプリッター'
            },
            sortMode: 0,
            filterListFlg: false
        }
    },
    watch: {
        // アドレスが?tunnelReviewの場合にcreateの設定が間に合わないためwatchで切替
        'threeListSortMode': function () {
            this.sortMode = this.threeListSortMode
        },
        'savedBalls': function () {
            if (this.sortMode === 1) {
                this.sortArray(this.savedBalls)
            }
            const balls = []
            if(this.savedBalls && this.savedBalls.length > 0){
                this.savedBalls.forEach(function (d) {
                    if(d?.data?.id) {
                        balls.push(d.data.id)
                    }
                })
            }
            if(balls.length > 0){
                this.$$router.replace({
                    query : {
                        balls : balls.join(",")
                    }
                })
            }
            else{
                this.$$router.replace({
                    query : {
                        balls : undefined
                    }
                })
            }
        }
    },
    mounted() {
        this.sortMode = this.threeListSortMode
        this.sortArray(this.savedBalls)
    },
    methods: {
        singlePitch: function (index) {
            this.$emit('single-pitch', index)
        },
        open: function (event) {
            $(event.target).closest('.ball').addClass('open')
            $(event.target).closest('.ball').children('.expand').css('max-height', '300px')
            $(event.target).closest('.ball').children('.expand').children('.ballInfo').fadeIn()
        },
        close: function (event) {
            $(event.target).closest('.ball').removeClass('open')
            $(event.target).closest('.ball').children('.expand').css('max-height', '0')
            $(event.target).closest('.ball').children('.expand').children('.ballInfo').fadeOut()
        },
        enable: function (event) {
            // $(event.target).closest('.ball').addClass('added')
            if ($(event.target).closest('.icons').children('.chkbx').prop('checked')) {
                $(event.target).closest('.ball').addClass('added')
            } else {
                $(event.target).closest('.ball').removeClass('added')
            }
        },
        editMultiPositions: function (id, event) {
            this.enable(event)
            this.$emit('edit-multi-positions', id, event)
        },
        removeSavedBall: function (index) {
            this.$emit('remove-saved-ball', index)
        },
        removeSortBall: function (index, key) {
            this.$emit('remove-saved-ball', index)
            this.removeSortArray(index, key)
        },
        changeBaseBall: function (index) {
            if (this.mode === 'tunnel') {
                this.$emit('change-base-ball', index)
            }
        },
        toggleSavedBall: function (bool, index) {
            this.$emit('toggle-saved-ball', bool, index)
        },
        getResultText: function (result, hit) {
            let text = ''
            if (result === 'Undefined' && hit === 'Undefined') {
                return '-'
            }
            if (result === 'InPlay') {
                if (this.setting.typesOfResult['InPlay'][hit] !== undefined) {
                    text = this.setting.typesOfResult['InPlay'][hit].name
                } else {
                    text = '-'
                }
            } else {
                if (this.setting.typesOfResult[result] !== undefined) {
                    text = this.setting.typesOfResult[result].name
                } else {
                    text = result
                }
            }
            return text
        },
        sortArray: function (data) {
            let that = this
            this.sortedArray = {
                'Fastball': [],
                'ChangeUp': [],
                'Curveball': [],
                'Cutter': [],
                'KnuckleBall': [],
                'Sinker': [],
                'Slider': [],
                'Splitter': []
            }
            data.forEach(function (d, i) {
                d['defaultNum'] = i
                that.sortedArray[d.data.pitchingdata.TaggedPitchType].push(d)
            })
            this.$forceUpdate()
        },
        removeSortArray: function (index, key) {
            let tmp = []
            this.sortedArray[key].forEach(function (d) {
                if (d.defaultNum !== index) {
                    tmp.push(d)
                }
            })
            this.sortedArray[key] = tmp
        },
        changeFilterListFlg: function () {
            if (this.filterListFlg === true) {
                this.filterListFlg = false
            } else if (this.filterListFlg === false) {
                this.filterListFlg = true
                this.sortArray(this.savedBalls)
            }
        },
        changeSortMode: function (num) {
            this.sortMode = num
            this.filterListFlg = false
            this.$forceUpdate()
            this.$emit('set-list-sort-mode', num)
            if (this.sortMode === 0) {
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 ソート変更', '登録順')
            } else if (this.sortMode === 1) {
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 ソート変更', '球種順')
            } else {
                common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 ソート変更', 'ピッチトンネルレビュー球')
            }
        },
        openSearchModal: function (type) {
            this.$emit('open-search-modal', type)
        }
    }
}
</script>
